import { createClient } from '@supabase/supabase-js'

const url = import.meta.env.VITE_SUPABASE_URL as string | undefined
const cle = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined

export const estConfigure = Boolean(url && cle)

if (!estConfigure) {
  // Message explicite plutôt qu'une erreur obscure au premier appel réseau.
  console.error(
    'Configuration manquante : copie le fichier .env.example en .env et ' +
      'renseigne VITE_SUPABASE_URL et VITE_SUPABASE_ANON_KEY.'
  )
}

export const supabase = createClient(url ?? 'http://localhost', cle ?? 'anon', {
  auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: false }
})
